import React from 'react'
import {Icon} from '@chakra-ui/react'

const SaveIconAlternative = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 23.9432L12 18.2289L20 23.9432V0H4V23.9432ZM6 20.0568V2H18V20.0568L12 15.7711L6 20.0568Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SaveIconAlternative
